import React, { useState } from 'react';
import axios from 'axios';

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8103/api').replace(/\/$/, '');

const EmailCapture: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/subscribe`, { email: email.trim() });
      setSubmitted(true);
    } catch (err: any) {
      const msg = err.response?.data?.detail || 'Something went wrong. Try again.';
      if (msg === 'Already subscribed' || err.response?.data?.message === 'Already subscribed') {
        setSubmitted(true);
      } else {
        setError(typeof msg === 'string' ? msg : 'Something went wrong. Try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-16 bg-gradient-to-br from-amber-500 to-amber-600 text-slate-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl font-bold sm:text-3xl">
          Get updates and offers
        </h2>
        <p className="mt-2 text-amber-900/80">
          We will only send useful farm tips and product news.
        </p>
        {submitted ? (
          <p className="mt-6 text-amber-900 font-medium">Thanks! We will be in touch.</p>
        ) : (
          <form onSubmit={handleSubmit} className="mt-6 flex flex-col sm:flex-row gap-3 justify-center max-w-md mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              className="rounded-xl px-4 py-3 text-slate-900 flex-1 min-w-0 border-2 border-amber-300 focus:border-amber-700 focus:outline-none"
              required
            />
            <button
              type="submit"
              disabled={loading}
              className="rounded-xl bg-slate-900 px-6 py-3 font-semibold text-white hover:bg-slate-800 transition disabled:opacity-60"
            >
              {loading ? 'Saving...' : 'Notify me'}
            </button>
          </form>
        )}
        {error && <p className="mt-3 text-red-800 text-sm">{error}</p>}
      </div>
    </section>
  );
};

export default EmailCapture;
